<div class="permission-gate">
  <div class="permission-gate__card">
    <i class="pi pi-shield permission-gate__icon"></i>
    <h1 class="permission-gate__title">Allow Access to Continue</h1>
    <p class="permission-gate__subtitle">
      We need these permissions to send you live order updates and confirm you're at the table.
    </p>

    <div class="permission-gate__item">
      <div class="permission-gate__item-info">
        <i class="pi pi-bell"></i>
        <div>
          <strong>Notifications</strong>
          <span>Get real-time updates on your order status</span>
        </div>
      </div>
      @if (notificationOk()) {
        <span class="permission-gate__status permission-gate__status--ok"><i class="pi pi-check"></i> Allowed</span>
      } @else if (notificationStatus() === 'denied') {
        <span class="permission-gate__status permission-gate__status--denied">Blocked</span>
      } @else {
        <button type="button" class="permission-gate__allow-btn" (click)="allowNotifications()">Allow</button>
      }
    </div>

    <div class="permission-gate__item">
      <div class="permission-gate__item-info">
        <i class="pi pi-map-marker"></i>
        <div>
          <strong>Location</strong>
          <span>Confirm you're at the store to place your order</span>
        </div>
      </div>
      @if (locationOk()) {
        <span class="permission-gate__status permission-gate__status--ok"><i class="pi pi-check"></i> Allowed</span>
      } @else if (locationStatus() === 'denied') {
        <span class="permission-gate__status permission-gate__status--denied">Blocked</span>
      } @else {
        <button type="button" class="permission-gate__allow-btn" (click)="allowLocation()">Allow</button>
      }
    </div>

    @if (notificationStatus() === 'denied' || locationStatus() === 'denied') {
      <p class="permission-gate__hint">
        You've blocked one or more permissions. Please enable them from your browser's site settings for this page,
        then reload.
      </p>
    }
  </div>
</div>
